// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Permission Elevation API
 * API for engineers to elevate and de-elevate their permissions within Aura.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const EnumElevationStatus = {
  ElevationStatusPending: 'pending',
} as const;
export type EnumElevationStatus =
  (typeof EnumElevationStatus)[keyof typeof EnumElevationStatus];

export function instanceOfEnumElevationStatus(value: any): boolean {
  for (const key in EnumElevationStatus) {
    if (Object.prototype.hasOwnProperty.call(EnumElevationStatus, key)) {
      if (
        EnumElevationStatus[key as keyof typeof EnumElevationStatus] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function EnumElevationStatusFromJSON(json: any): EnumElevationStatus {
  return EnumElevationStatusFromJSONTyped(json, false);
}

export function EnumElevationStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnumElevationStatus {
  return json as EnumElevationStatus;
}

export function EnumElevationStatusToJSON(
  value?: EnumElevationStatus | null,
): any {
  return value as any;
}

export function EnumElevationStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): EnumElevationStatus {
  return value as EnumElevationStatus;
}
